import {requestJSON, resolveMediaURL} from './direct';
import {rasterImage} from './imageFormats';

export const clientSections = ['materials', 'input', 'measurement', 'result'];
export function previewable(node) {
  return rasterImage(node)
    && (!node.rights || node.rights.includes('download'));
}
export function folderPrefix(objectId, section) {
  if (!/^[1-9]\d*$/.test(String(objectId)) || !clientSections.includes(section)) {
    throw new Error('Некорректная ссылка на папку.');
  }
  return `/main/api/media/client/applications/${objectId}/${section}/`;
}
export function guestFolderPrefix(shareToken) {
  if (!/^[A-Za-z0-9_-]{32,128}$/.test(String(shareToken))) throw new Error('Некорректная ссылка на материалы.');
  return `/main/api/media/guest/${shareToken}/materials/`;
}
export function sharedFolderPrefix(shareToken) {
  if (!/^[A-Za-z0-9_-]{32,128}$/.test(String(shareToken))) throw new Error('Некорректная ссылка на папку.');
  return `/main/api/media/guest-shares/${shareToken}/materials/`;
}
export async function clientFileURL(apiURL, prefix, node, token, preview, signal) {
  if (!token) throw new Error('Войдите в свой кабинет, чтобы открыть материалы.');
  if (!node?.id || node.kind !== 'file' || (node.rights && !node.rights.includes('download')) || (preview && !previewable(node))) {
    throw new Error('Этот файл недоступен для просмотра.');
  }
  const result = await requestJSON(`${apiURL}${prefix}files/${encodeURIComponent(node.id)}/download/`, {
    method: 'POST', headers: {Authorization: `ClientToken ${token}`, 'Content-Type': 'application/json'},
    body: JSON.stringify(preview ? {preview: true} : {}), cache: 'no-store',
  }, signal);
  return resolveMediaURL(apiURL, result.url, {preview, signal});
}
